<template>
  <div class="wrap">
    <aside id="secondary" class="widget-area">
      <section class="widget widget_categories">
        <h2 class="widget-title">{{ $t('products.title') }}</h2>
        <ul>
          <li class="cat-item" v-for="(item,index) in titleList" :key="index">
            <a @click="changeType(item.t_1.type)">{{ item.t_1.name }}</a>
            <ul class="children">
              <li
                class="cat-item"
                :class="{'current-cat':child.type==productType}"
                v-for="(child,index) in item.t_2s"
                :key="index"
              >
                <a @click="changeType(child.type)">{{ child.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </aside>
    <div id="primary" class="content-area">
      <main id="main" class="site-main">
        <template v-for="(item,index) in productList">
          <article
            v-if="productType=='all'||productType==item.type"
            :key="index"
            class="post type-post status-publish format-standard has-post-thumbnail hentry"
          >
            <div class="post-thumbnail">
              <router-link :to="item.link">
                <img
                  :src="item.image"
                  class="attachment-twentyseventeen-featured-image size-twentyseventeen-featured-image wp-post-image"
                >
              </router-link>
            </div>
            <header class="entry-header">
              <h2 class="entry-title">
                <router-link :to="item.link">{{ $t(item.name) }}</router-link>
              </h2>
            </header>
            <div class="entry-content"></div>
          </article>
        </template>
      </main>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      productList: [],
      productType: "all"
    };
  },
  computed: {
    titleList() {
      const list = this.$t("products").titleList;
      return [
        {
          t_1: { name: list[0].t_1, type: "all" },
          t_2s: [
            { name: list[0].t_2s[0], type: "smart" },
            { name: list[0].t_2s[1], type: "yx" },
            { name: list[0].t_2s[2], type: "glb" }
          ]
        }
      ];
    }
  },
  created() {
    axios.get("productList.json").then(res => {
      this.productList = res.data;
    });
  },
  methods: {
    changeType(type) {
      this.productType = type;
      console.log(this.productType);
    }
  },
  mounted() {
    document.body.className = "blog hfeed has-sidebar colors-light";
  }
};
</script>
<style lang="stylus" scoped>
h2 {
  cursor: default;
}

a {
  cursor: pointer;
}
</style>
